import { z } from 'zod';
import { lastKnownLocationSchema } from '../../common/last-known-location.schema';

/**
 * Two-tier last-known-location snapshot for a user. See
 * `docs/ai/user-signals.md`.
 *
 * `accurate` and `approximate` are independent — writers must never
 * clobber `accurate` (GPS-quality) with an `approximate` write
 * (IP / user-stated / phone-country / saved-location-default). The
 * fleet god-view and agent tools consult both tiers explicitly
 * rather than a single collapsed "best guess" so they can render
 * an honest fidelity badge next to the location.
 */
export const userMetaLocationSchema = z.object({
  /**
   * Last GPS-quality point. Only writers with a `source` of
   * `app_foreground` / `app_background` / `iot_gps` update this.
   */
  accurate: lastKnownLocationSchema.optional(),
  /**
   * Last low-fidelity guess. Writers with any of the non-GPS
   * sources (`ip`, `user_stated`, `phone_country`,
   * `saved_location_default`) update this.
   */
  approximate: lastKnownLocationSchema.optional(),
});
export type UserMetaLocation = z.infer<typeof userMetaLocationSchema>;
